<mwe-address [address]="address" />

@if (isCollapsable) {
  <mwe-collapse
    [collapseId]="collapseId"
    titleMessageKey="summary.whatNext"
    [initialState]="initialState"
    [isCollapseHeaderVisible]="isCollapseHeaderVisible"
    [showBoxStyle]="false"
    [contentClass]="'pt-4'"
  >
    <ng-container *ngTemplateOutlet="content" />
  </mwe-collapse>
} @else {
  <div class="mt-4">
    <ng-container *ngTemplateOutlet="content" />
  </div>
}

<ng-template #content>
  @if (stromOrGasProducts?.length || selectedTariffs()?.length) {
    <div data-test="products-summary-strom-gas-container">
      <h4 [translate]="registerStromGasTitle"></h4>

      <!--  Removed for Change MWE-15157 -->
      @if (registerStromGasText) {
        <p
          class="text--big"
          data-test="products-summary-strom-gas-register-text"
          [innerHTML]="registerStromGasText | translate: { registrationAt: registrationAt }"
        ></p>
      }
      <div class="row" data-test="products-summary-strom-gas-products">
        @if (selectedTariffs()?.length) {
          <mwe-tariff-selection-container
            [selectedTariffs]="selectedTariffs()"
            [isReadOnly]="true"
            [isKundeWerden]="isKundeWerden"
            class="d-block mb-4"
          />
        } @else {
          @for (product of stromOrGasProducts; track product) {
            <div class="col-12 col-lg-6 mb-4">
              <mwe-basic-card>
                <mwe-wizard-product-card
                  [product]="product"
                  [showTariffDetailsLink]="showTariffDetailsLink"
                  [showTariffDetails]="showStromGasTarifDetails && showTariffDetails"
                  [isAvailable]="true"
                  [tariffClasses]="product.tariffClasses"
                  [tarifKey]="product.tarifKey"
                  [productSelection]="productSelection"
                  [grundpreisLabelOverwrite]="grundpreisLabelOverwrite"
                  [attr.data-test]="'products-summary-card-' + product.category?.toLowerCase()"
                />
              </mwe-basic-card>
            </div>
          }
        }
      </div>
      @if (firstname || lastname || businessData) {
        <div class="mb-4">
          <mwe-basic-card>
            <h6 [translate]="customerDataType !== 'Businesskunde' ? 'summary.personalData' : 'summary.businessData'"></h6>
            <div class="row w-100">
              <div class="col-12">
                <ul class="list-separated spacing-4" data-test="products-summary-customerData">
                  <li data-test="products-summary-customerData-name">
                    <p class="text--big mb-0">
                      <strong><span translate="summary.customerData"></span></strong><br />
                      @if (!!customerDataType && !isKundeWerden) {
                        <span>{{ customerDataType }} <br /></span>
                      }

                      @if (customerDataType === 'Businesskunde') {
                        @if (businessData?.companyName) {
                          <span> <span translate="newClient.summary.companyName"></span>: {{ businessData.companyName }} </span>
                        }
                        @if (businessData?.uidNumber) {
                          <span> <br /><span translate="newClient.summary.uidNumber"></span>: {{ businessData.uidNumber }} </span>
                        }
                        @if (businessData?.corporateRegisterNumber) {
                          <span>
                            <br /><span translate="newClient.summary.corporateRegisterNumber"></span>:
                            {{ businessData.corporateRegisterNumber }}
                          </span>
                        }
                      }
                      <span data-test="products-summary-customer-name">
                        {{ getFullNameWithTitle() }}
                      </span>
                      @if (!customerDataType || (!!customerDataType && customerDataType === 'Privatkunde')) {
                        <span data-test="products-summary-customer-birthdate"> <br />{{ birthDate }} </span>
                      }
                      @if (telefonNumber()) {
                        <br />
                        <span data-test="products-summary-customer-phonenumber">
                          {{ telefonNumber() }}
                        </span>
                      }
                      <br />
                      <span data-test="products-summary-customer-email">
                        {{ email }}
                      </span>
                      <ng-content select="[slot='products-summary-customerData-name-additionalContent']" />
                    </p>
                  </li>
                  @if (contractInfos()?.length) {
                    @for (contractInfo of contractInfos(); track contractInfo) {
                      <li data-test="products-summary-customerData-contract-info">
                        <mwe-product-summary-contract-info
                          [contractInfos]="contractInfo"
                          [showDeliveryInfos]="showDeliveryInfosContractInfo()"
                        />
                      </li>
                    }
                  }
                  @if (idCard && idCard.art === 'Ausweis') {
                    <li data-test="products-summary-customerData-idCard">
                      <p class="text--big mb-0">
                        <strong><span translate="summary.idData"></span></strong>
                        <br />
                        {{ idCard.type }}, {{ idCard.number }}, {{ idCard.issuer }}
                      </p>
                    </li>
                  }
                </ul>
              </div>
            </div>
          </mwe-basic-card>
        </div>
      }
      <div class="mb-4">
        <mwe-basic-card>
          <mwe-products-summary-invoice-old
            [isPaymentInfoVisible]="isPaymentInfoVisible"
            [personalBillingTitle]="personalBillingTitle"
            [eRechnungInfo]="eRechnungInfo"
            [paymentIcon]="paymentIcon"
            [paymentText]="paymentText"
            [formattedAddress]="formattedAddress"
            [contactDataEmailAddress]="contactDataEmailAddress"
            [additionalBulletPoints]="additionalBulletPointsStromGas"
            [areBankAccountInfoTextsVisible]="areBankAccountInfoTextsVisible"
            [productCategories]="productCategories"
            [invoiceInfoAlertMessage]="invoiceInfoAlertMessage"
            [infoTextCardLabel]="infoTextCardLabel"
          />
        </mwe-basic-card>
      </div>
      <ng-content select=".after-invoice" />
      @if (showMeterReading || voucherInfo) {
        <div class="mb-4">
          <mwe-basic-card>
            <h6 translate="summary.additionalDetails"></h6>
            <div class="row w-100">
              <div class="col-12">
                <ul class="list-separated spacing-4" data-test="products-summary-additionalDetails">
                  @if (showMeterReading) {
                    <li data-test="products-summary-additionalDetails-showMeterReading">
                      <p class="text--big mb-0">
                        <strong><span translate="summary.meterReading.title"></span></strong><br />
                        <span translate="summary.meterReading.description"></span>
                      </p>
                    </li>
                  }
                  @if (voucherInfo) {
                    <li data-test="products-summary-additionalDetails-voucher">
                      <p class="text--big mb-0">
                        <strong
                          ><span
                            translate="summary.voucherInfo.title"
                            [translateParams]="{ voucherCode: voucherInfo.aktionscode }"
                          ></span></strong
                        ><br />
                        @if (voucherStrom?.length > 0) {
                          <span [innerHTML]="voucherStrom + '<br/>'"></span>
                        }
                        @if (voucherGas?.length > 0) {
                          <span [innerHTML]="voucherGas + '<br/>'"></span>
                        }
                      </p>
                    </li>
                  }
                  @if (mgmCode) {
                    <li data-test="products-summary-additionalDetails-mgmCode">
                      <p class="text--big mb-0">
                        <strong><span translate="newClient.mgm.summaryTitle"></span></strong><br />
                        <span> {{ mgmCode }}</span>
                      </p>
                    </li>
                  }
                </ul>
              </div>
            </div>
          </mwe-basic-card>
        </div>
      }
      @if (registerStromGasInfoMessage) {
        <div class="w-100 mt-4 mb-4">
          <mwe-alert type="info" [messageKey]="registerStromGasInfoMessage" />
        </div>
      }
    </div>
  }

  @if (fernwaermeProducts?.length) {
    <div data-test="products-summary-fernwaerme-container">
      @if (stromOrGasProducts?.length) {
        <hr />
      }
      <h6 translate="summary.productsFromWE"></h6>
      <p class="text--big" [translate]="registerFernwaermeSubTitle"></p>
      <div class="row">
        @for (product of fernwaermeProducts; track product) {
          <div class="col-12 col-lg-6 mb-4">
            @if (useNewWaermeCards) {
              <mwe-tariff-card-waerme [product]="product" />
            } @else {
              <mwe-basic-card>
                <mwe-wizard-product-card
                  [product]="product"
                  [showTariffDetails]="false"
                  [isAvailable]="true"
                  [tariffClasses]="product.tariffClasses?.length > 0 && product.tariffClasses[0] !== '' ? product.tariffClasses : []"
                  [showWaermeTariffClassesAsideOfIcon]="showWaermeTariffClassesAsideOfIcon"
                />
              </mwe-basic-card>
            }
          </div>
        }
      </div>
      @if (showFernwaermeInvoiceData) {
        <div class="mb-4">
          <mwe-basic-card>
            <mwe-products-summary-invoice-old
              [isPaymentInfoVisible]="isPaymentInfoVisible"
              [personalBillingTitle]="personalBillingTitle"
              [eRechnungInfo]="eRechnungInfo"
              [paymentIcon]="paymentIcon"
              [paymentText]="paymentText"
              [formattedAddress]="formattedAddress"
              [contactDataEmailAddress]="contactDataEmailAddress"
              [additionalBulletPoints]="additionalBulletPointsFernwaerme"
              [areBankAccountInfoTextsVisible]="areBankAccountInfoTextsVisible"
              [productCategories]="productCategories"
            />
          </mwe-basic-card>
        </div>
      }
      <ng-content select="[sepa-mandat-fw]" />
      <div class="w-100 mt-4 mb-7">
        <mwe-alert type="info" [messageKey]="registerFernwaermeText" [placeholderMap]="registerFernwaermeTextPlaceholder" />
      </div>
    </div>
  }
</ng-template>
